import LoginLayout from "@/components/Layout/LoginLayout";
import { SigninWithEmail } from "@/features/auth";
import Head from "next/head";
import type { ReactElement } from "react";

function SigninWithEmailPage() {
	return (
		<>
			<Head>
				<title>メールでログイン | ケアミー</title>
				<meta name="robots" content="noindex" />
			</Head>

			<SigninWithEmail />
		</>
	);
}

SigninWithEmailPage.getLayout = function getLayout(page: ReactElement) {
	return <LoginLayout>{page}</LoginLayout>;
};

export default SigninWithEmailPage;
